import React, { ReactElement } from 'react';
import MenuInterface, { MenuKeys } from 'modules/shared/layout/menu/interfaces/menu.interface';
import Icon from 'atomic/icon';

import './department-menu-item.scss';

interface DepartmentMenuItemProps {
    url: MenuInterface['url'];
    name: MenuInterface[MenuKeys.name];
    icon?: MenuInterface[MenuKeys.icon];
}

const DepartmentMenuItem: React.FC<DepartmentMenuItemProps> = ({ url, name, icon }): ReactElement => (
    <a href={url} className="department-menu-item" title={name}>
        {icon && (
            <Icon name={icon} size={22} />
        )}
        {name}
    </a>
);

export default DepartmentMenuItem;
